import Order from "models/order";
import { v4 as uuidv4 } from "uuid";
import { plainToClass } from "class-transformer";

const SESSION_STORAGE_ORDERS_KEY = "orders";

export default class OrderRepository {
  getLastOrder(): Order | undefined {
    return OrderRepository.getOrders()
      .sort((order1, order2) => new Date(order2._createdAt).getTime() - new Date(order1._createdAt).getTime())
      .shift();
  }

  getOrder(id: string): Order | undefined {
    return OrderRepository.getOrders().find(order => order.id === id);
  }

  addOrder(order: Order) {
    if (!order.id) {
      order.id = uuidv4();
      order._createdAt = new Date();
    }

    let orders: Order[] = [];
    const ordersString = sessionStorage.getItem(SESSION_STORAGE_ORDERS_KEY);
    if (ordersString) {
      orders = JSON.parse(ordersString) as Order[];
    }
    orders.push(order);

    sessionStorage.setItem(SESSION_STORAGE_ORDERS_KEY, JSON.stringify(orders));
  }

  updateOrder(order: Order) {
    this.removeOrder(order.id);

    this.addOrder(order);
  }

  private static getOrders() {
    let orders: Order[] = [];
    const ordersString = sessionStorage.getItem(SESSION_STORAGE_ORDERS_KEY);
    if (ordersString) {
      orders = JSON.parse(ordersString) as Order[];
    }

    return orders.map(order => plainToClass(Order, order));
  }

  removeOrder(id: string) {
    let orders = OrderRepository.getOrders();

    orders = orders.filter(order => order.id !== id);

    OrderRepository.storeOrders(orders);
  }

  private static storeOrders(orders: Order[]) {
    sessionStorage.setItem(SESSION_STORAGE_ORDERS_KEY, JSON.stringify(orders));
  }

  async clearOrders() {
    sessionStorage.removeItem(SESSION_STORAGE_ORDERS_KEY);
  }
}
